/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DelegationsCreated,
    DelegationsCreatedFromJSON,
    DelegationsCreatedFromJSONTyped,
    DelegationsCreatedToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface DelegationsCreatedResponse
 */
export interface DelegationsCreatedResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof DelegationsCreatedResponse
     */
    msg: string;
    /**
     * 
     * @type {DelegationsCreated}
     * @memberof DelegationsCreatedResponse
     */
    entry: DelegationsCreated;
}

export function DelegationsCreatedResponseFromJSON(json: any): DelegationsCreatedResponse {
    return DelegationsCreatedResponseFromJSONTyped(json, false);
}

export function DelegationsCreatedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegationsCreatedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': DelegationsCreatedFromJSON(json['entry']),
    };
}

export function DelegationsCreatedResponseToJSON(value?: DelegationsCreatedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': DelegationsCreatedToJSON(value.entry),
    };
}


